import React from 'react';
import './App.css';
import MainPage from './components/MainPage';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {ThemeProvider} from '@mui/material/styles';
import {theme} from './styles/theme';
import ReactGA from "react-ga4";
import NotFound from "./pages/NotFound";

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TAG);

function App() {
    return (
        <ThemeProvider theme={theme}>
            <div className="screen">
                <BrowserRouter>
                    <Routes>
                        {/* Blocked route returns 404 with no header */}
                        <Route path="/latest/meta-data" element={<NotFound/>}/>

                        {/* All standard routes go through MainPage (with header) */}
                        <Route path="/*" element={<MainPage/>}/>

                    </Routes>
                </BrowserRouter>
            </div>
        </ThemeProvider>
    );
}

export default App;



